// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Tab_contentWrapper__5W18s","detailsLayout":"Tab_detailsLayout__IDMzS","innerSidebar":"Tab_innerSidebar__e4D0P","active":"Tab_active__l3K6q"};